import type { ReactNode } from 'react';

export const symbol_diagonal_line: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M768.47-80Q722-80 689-112.67q-33-32.66-33-79.33 0-15.05 3.5-29.02Q663-235 670-247L247-671q-12 7-25.98 11-13.97 4-29.02 4-46 0-79-33t-33-79q0-46 32.53-79t79-33Q238-880 271-847.33q33 32.66 33 79.33 0 15.05-4 29.03Q296-725 289-713l423 424q12-7 26-11t30-4q46.67 0 79.33 32.53 32.67 32.53 32.67 79T847.47-113q-32.53 33-79 33Z"
		/>
	</svg>
);
